import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import Link from '../../components/common/Link';

import * as EventsActionCreators from '../../redux/events';

const StyledDiv = styled.div`
  display: inline;
  margin-right: 30px;
`;

class EventsEditPage extends Component {
  state = {
    privateField: false,
    displayAtHomeField: false
  };

  async componentDidMount() {
    const {
      actions,
      match: { params }
    } = this.props;
    try {
      const promises = [
        actions.getEvent(params.id),
        actions.getEventGuestCounts(params.id),
        actions.getEventTicketSales(params.id)
      ];
      await Promise.all(promises);
    } catch (e) {
      console.error('ERROR: Event View', e);
    }
  }

  componentDidUpdate(prevProps) {
    const { event } = this.props;
    if (event && !prevProps.event) {
      this.setState({
        privateField: !!event.private,
        displayAtHomeField: !!event.display_at_home
      });
    }
  }

  onClickUpdate = async () => {
    const { actions, event, history } = this.props;
    const { privateField, displayAtHomeField } = this.state;
    const updateData = {
      private: privateField,
      display_at_home: displayAtHomeField
    };

    await actions.updateEvent(event.id, updateData);
    history.push('/events');
  };
  onClickDelete = async () => {
    const { actions, event, history } = this.props;
    const r = window.confirm('Are you sure you want to delete this event!');
    if (r === true) {
      await actions.deleteEvent(event.id);
      history.push('/events');
    }
  };
  onChangeSwitch = fieldName => (e, checked) =>
    this.setState({ [fieldName]: checked });

  render() {
    const { event, guestCounts, ticketSales } = this.props;
    if (!event) return null;
    return (
      <div>
        {guestCounts ? (
          <Fragment>
            <h2>Total Guest Count</h2>
            {guestCounts.total}
            <h2>Total Ticket Types</h2>
            {guestCounts.ticket_types.length}
            <h2>Total checkins</h2>
            {guestCounts.checkedInCount}
          </Fragment>
        ) : null}
        {ticketSales ? (
          <Fragment>
            <h2>Total revenue</h2>
            HK$ {ticketSales.total}
          </Fragment>
        ) : null}
        <h2>Edit {event.name}</h2>
        <div>
          Is private?
          <Switch
            checked={this.state.privateField}
            onChange={this.onChangeSwitch('privateField')}
          />
        </div>
        <div>
          Display at home?
          <Switch
            checked={this.state.displayAtHomeField}
            onChange={this.onChangeSwitch('displayAtHomeField')}
          />
        </div>
        <div>
          <StyledDiv>
            <Link to="/events">
              <Button variant="outlined" color="primary">
                CANCEL
              </Button>
            </Link>
          </StyledDiv>
          <StyledDiv>
            <Button
              variant="contained"
              color="danger"
              onClick={this.onClickDelete}
            >
              Delete
            </Button>
          </StyledDiv>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onClickUpdate}
          >
            Update
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    event: state.events.event,
    guestCounts: state.events.guestCounts,
    ticketSales: state.events.ticketSales
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(EventsActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EventsEditPage)
);



// WEBPACK FOOTER //
// ./src/pages/events/edit.js